import { makeActionCreator } from '../../../../utilities'
import { OperationsConstants } from './operations.constants'

export const setStretcherChairMovingTo = makeActionCreator(
  OperationsConstants.SET_STRETCHER_CHAIR_MOVING_TO,
  'stretcherChairMovingTo'
)
export const setJointCommissionTimeOut = makeActionCreator(
  OperationsConstants.SET_JOINT_COMMISSION_TIME_OUT,
  'jointCommissionTimeOut'
)
export const setRightPatient = makeActionCreator(OperationsConstants.SET_RIGHT_PATIENT, 'rightPatient')
export const setRightProcedure = makeActionCreator(OperationsConstants.SET_RIGHT_PROCEDURE, 'rightProcedure')
export const setRightConsent = makeActionCreator(OperationsConstants.SET_RIGHT_CONSENT, 'rightConsent')
export const setRightSiteSide = makeActionCreator(OperationsConstants.SET_RIGHT_SITE_SIDE, 'rightSiteSide')
export const setRightPosition = makeActionCreator(OperationsConstants.SET_RIGHT_POSITION, 'rightPosition')
export const setComplete = makeActionCreator(OperationsConstants.SET_COMPLETE, 'complete')
export const setSafetyBrief = makeActionCreator(OperationsConstants.SET_SAFETY_BRIEF, 'safetyBrief')
export const setLastName = makeActionCreator(OperationsConstants.SET_LAST_NAME, 'lastName')
export const setFirstName = makeActionCreator(OperationsConstants.SET_FIRST_NAME, 'firstName')
export const setWeight = makeActionCreator(OperationsConstants.SET_WEIGHT, 'weight')
export const setWeightUnit = makeActionCreator(OperationsConstants.SET_WEIGHT_UNIT, 'weightUnit')
export const setHearingPrecautions = makeActionCreator(
  OperationsConstants.SET_HEARING_PRECAUTIONS,
  'hearingPrecautions'
)
export const setEnvironmentalControls = makeActionCreator(
  OperationsConstants.SET_ENVIRONMENTAL_CONTROLS,
  'environmentalControls'
)
export const setSafetyRestraints = makeActionCreator(OperationsConstants.SET_SAFETY_RESTRAINTS, 'safetyRestraints')
export const setSeizurePrecautions = makeActionCreator(
  OperationsConstants.SET_SEIZURE_PRECAUTIONS,
  'seizurePrecautions'
)
export const setPatientLoadedCold = makeActionCreator(OperationsConstants.SET_PATIENT_LOADED_COLD, 'patientLoadedCold')
export const setPatientLoadedHot = makeActionCreator(OperationsConstants.SET_PATIENT_LOADED_HOT, 'patientLoadedHot')
export const setPatientOffloadCold = makeActionCreator(
  OperationsConstants.SET_PATIENT_OFFLOAD_COLD,
  'patientOffloadCold'
)
export const setPatientOffloadHot = makeActionCreator(OperationsConstants.SET_PATIENT_OFFLOAD_HOT, 'patientOffloadHot')
export const setPatientMonitoring = makeActionCreator(OperationsConstants.SET_PATIENT_MONITORING, 'patientMonitoring')
export const setPediatricStretcherChair = makeActionCreator(
  OperationsConstants.SET_PEDIATRIC_STRETCHER_CHAIR,
  'pediatricStretcherChair'
)
export const setPediatricSafetyRestraintDevice = makeActionCreator(
  OperationsConstants.SET_PEDIATRIC_SAFETY_RESTRAINT_DEVICE,
  'pediatricSafetyRestraintDevice'
)
export const setBabyPod = makeActionCreator(OperationsConstants.SET_BABYPOD, 'babyPod')
export const setPediMate = makeActionCreator(OperationsConstants.SET_PEDIMATE, 'pediMate')
export const setPatientPersonalProtectiveEquipment = makeActionCreator(
  OperationsConstants.SET_PATIENT_PERSONAL_PROTECTIVE_EQUIPMENT,
  'patientPersonalProtectiveEquipment'
)

export const saveOperations = makeActionCreator(OperationsConstants.SAVE_OPERATIONS, 'data')
export const resetState = makeActionCreator(OperationsConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(OperationsConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(OperationsConstants.SET_STATE, 'operationsState')
export const setDateTime = makeActionCreator(OperationsConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(OperationsConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectOperationsProcedure = makeActionCreator(OperationsConstants.ON_SELECT_OPERATIONS)
export const setUpdateInputRows = makeActionCreator(OperationsConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(OperationsConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(OperationsConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(OperationsConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setJointCommissionTimeOutArray = makeActionCreator(
  OperationsConstants.SET_JOINT_COMMISSION_TIMEOUT_ARRAY,
  'jointCommissionTimeOutArray'
)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
